import { Namespace, useT, type TranslationKey } from "@racoon/i18n";
import { JOB_STATUS_TONE, STATUS_TONE_CLASS } from "@racoon/lib";
import { StatusPill, cn } from "@racoon/ui";

/** A job's status in its palette colour; `status` is the enum's name, as on an OrderRow. */
export const JobStatusPill = ({ status, className }: { status: string; className?: string }) => {
  const t = useT();
  const tone = STATUS_TONE_CLASS[JOB_STATUS_TONE[status] ?? "cancelled"];
  return (
    <StatusPill tone={cn(tone.bg, tone.color, className)}>
      {t(Namespace.Enum, status as TranslationKey<Namespace.Enum>)}
    </StatusPill>
  );
};
